import React,{  useEffect, useState } from "react";
import { Divider, Steps } from "antd";
import { calculateTicketRowAmount } from "../TicketService";

import AlertBox from "../../../shared/AlertBox";
import LoadingBox from "../../../shared/LoadingBox";
import DatePicker from "../../../shared/DatePicker";
import { formatToCurrencyWithScale, formatValidInput} from "../../../../helpers/FormatHelper";
import NewDynamicTable from "../../../shared/NewDynamicTable";
import OutgoingRow from "./OutgoingRow";

export function OutgoingInformationScreen({objTicket, customerName, customerID, ticketType, currenciesList, updateTicket, changeScreen,
                        contactID, contactName, newTicket, instruments, deliveryMethods, balances, beneficiaries, customers}) {

    const today = new Date();
    const [deliveryDate, setDeliveryDate] = useState(today);
    
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showDuplicateCcyConfirmation, setShowDuplicateCcyConfirmation] = useState(false);
    const [duplicateCcyMessage, setDuplicateCcyMessage] = useState('');
    const [newRow, setNewRow] = useState({CurrencyID:''});
    const [showNewTicketConfirmation, setShowNewTicketConfirmation] = useState(false);
    const [comments, setComments] = useState('');
    const [customerList, setCustomerList] = useState([]);
    const [recipientList, setRecipientList] = useState([]);
  
    const startDate = new Date();
    startDate.setDate(startDate.getDate() + 1);
    const [ticketRows, setTicketRows] = useState([{
      key: 1,
      RecipientType:'Beneficiary',
      RecipientID: -1,
      RecipientName:'',
      PersonID:'',
      CurrencyID:'',
      Amount:0,
      Instrument:'',
      DeliveryMethod:'',
      BankAccountName:-1,
      validations:{
            RecipientType: true,
            RecipientID: true,
            CurrencyID: true,
            Amount: true,
            Instrument: true,
            DeliveryMethod: true}       
    }]);
    
    const [validationsHeader, setValidationsHeader] = useState(
        {
          DeliveryDate: true     
        }
      )

    const getNextDay = () =>{
      const startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      let validNextDate = false;

      //if(allowTicketCurrentDate)
      //{
      //  startDate.setDate(startDate.getDate() - 1);
      //}

      while(!validNextDate)
      {
        startDate.setDate(startDate.getDate() + 1);

        if(startDate.getDay() !== 0 && startDate.getDay()!== 6)
        {
          validNextDate = true;
        }
     }
      return new Date(startDate);
    }

    useEffect(()=>{      
      if(customers && customers.length > 0)
      {
        const custList = [...customers].filter(c => c.CustomerID !== customerID);
        setCustomerList(custList);

        const recipients = [...new Set([...beneficiaries, ...custList])];
        setRecipientList(recipients);
      }

    },[customers]);

     useEffect(()=>{
        
        const nextDay = getNextDay();
      
        setDeliveryDate(nextDay);
        
      },[])

    useEffect(()=> {

      if(objTicket && objTicket.TicketRows && objTicket.TicketRows.length>0)
      {
        setTicketRows(objTicket.TicketRows);     
      }

      if(objTicket.DeliveryDate && objTicket.DeliveryDate !== '')
      {
        setDeliveryDate(objTicket.DeliveryDate);
      }

      setComments(objTicket.Comments);
      
    },[objTicket])


    const currencyAlreadyExists = (recipientType, recipientID, currencyID, key, instrument, deliveryMethod) => {
      if(newRow && newRow.CurrencyID === 'Valid')
        return true;

      const existCCy = ticketRows.find(o => o.RecipientType === recipientType && o.RecipientID === recipientID && o.CurrencyID === currencyID && o.key !== key && o.Instrument === instrument && o.DeliveryMethod === deliveryMethod
        && instrument !== '' && deliveryMethod !== ''
      );
      if(existCCy)
        return false
      return true;
    }

    const rowIsValid = (lastTicket) =>{
      
      const prev = lastTicket.validations;

      const validations = {
        ...prev,
        Amount: lastTicket.Amount > 0,
        RecipientType: lastTicket.RecipientType !== '',
        RecipientID: lastTicket.RecipientID !== -1,
        CurrencyID: !!lastTicket.CurrencyID && currencyAlreadyExists(lastTicket.RecipientType,lastTicket.RecipientID, lastTicket.CurrencyID, lastTicket.key, lastTicket.Instrument, lastTicket.DeliveryMethod),    
        Instrument: lastTicket.Instrument !== '',
        DeliveryMethod: lastTicket.Instrument.includes('Hold') || lastTicket.DeliveryMethod !== ''
      };

      return validations;
    }

    const onAddClick =() =>{
        const ticket = {};
        ticket.key = ticketRows.length > 0 ? (ticketRows[ticketRows.length - 1].key + 1) : 1;
        ticket.Amount = 0;
        ticket.CurrencyID = '';
        ticket.Instrument = '';
        ticket.DeliveryMethod = '';       

        ticket.validations={
            CurrencyID: true,
            Amount: true,
            Instrument: true,
            DeliveryMethod: true
        }        

        const tickets = [...ticketRows];
        if(tickets.length > 0)
        {
          const lastTicket = tickets[tickets.length - 1];
          const validations = rowIsValid(lastTicket)
          tickets[tickets.length - 1] = {...lastTicket,validations};
          setNewRow({CurrencyID:''});
            
          if(Object.values(validations).every(Boolean))
          {
            ticket.validations = validations;
            tickets.push(ticket);
          }   
          else
          {
          const duplicateCcy = tickets.find(c => !c.validations.CurrencyID && c.CurrencyID !== '')
            if(duplicateCcy)
            {
              ticket.validations = validations;
              setNewRow(ticket);
              //setDuplicateCcyMessage(`The Ticket has duplicate Currencies. Do you want to continue?`);       
              //setShowDuplicateCcyConfirmation(true);
              setAlertTitle('Error');
              setAlertMessage('The Ticket has duplicate Currencies.');       
              setShowAlert(true);

            }
            else
            {
              setAlertTitle('Error');
              setAlertMessage('You missed some fields.');       
              setShowAlert(true);
            } 
          }               
        }
        else
        {
          tickets.push(ticket);
        }
        setTicketRows(tickets);
    }

    const onDeleteRow = (key) => {
        let rows = [...ticketRows];    
        rows = rows.filter((d) => d.key !== key);
        setTicketRows(rows);
    };

    const amountIsValid = (key, value, currency) => {
      let valid = false;

      const rows = ticketRows.filter((r) => r.key !== key && r.CurrencyID === currency);
      const balance = balances.filter((b) => b.Currency === currency);

      let amount = Number(value);
      if(rows.length > 0)
      {
        const totalAmount = rows.reduce((acc, row) => acc + Number(row.Amount), 0);
        amount += totalAmount;
      }

      if(balance.length > 0)
      {
        const availableBalance = balance[0]['Balance$'];

        if(amount <= availableBalance)
        {
          valid = true;
        }
        else
        {
          setAlertTitle('Error');
          setAlertMessage('There is not enough balance.');       
          setShowAlert(true);
        }
      }
      else{
          setAlertTitle('Error');
          setAlertMessage('There is not enough balance.');       
          setShowAlert(true);
      }

      return valid;
    }
    
    const onUpdateFieldRow = (key, Field, value) =>{
        setTicketRows(prev => {
            const rows = [...prev];
            const index = rows.findIndex((r) => r.key === key );
            if(index > -1)
            {
                rows[index] = { ...rows[index], [Field]: value };
            }
            return rows;
        });
    }

  const validHeader= ()=>{
     const prev = validationsHeader;
     const startDate = new Date();
     
    /* if(!allowTicketCurrentDate)
     {
      startDate.setDate(startDate.getDate() + 1);
     }
*/
     const today = startDate.setHours(0,0,0,0);
    const selectedDateTime = new Date(deliveryDate).setHours(0, 0,0,0);

    const validations = {
        ...prev,
        DeliveryDate: selectedDateTime >= today
      };

    setValidationsHeader(validations);

    return Object.values(validations).every(Boolean)
  }

  const onNextClick = () =>{    
    const ticketsR = [...ticketRows];
    if(ticketsR.length > 0)
    {

    const ticketRowsValidated = ticketRows.map(o => ({
        ...o,
        validations: rowIsValid(o)
      }));
      setTicketRows(ticketRowsValidated);

      const allValid = ticketRowsValidated.every(o =>
        Object.values(o.validations).every(Boolean)
      );

      const headerIsValid = validHeader();
      setNewRow({CurrencyID:''});
        
      if(allValid && headerIsValid)
      {
        objTicket.DeliveryDate = deliveryDate;
        objTicket.TicketRows = ticketRowsValidated;
        objTicket.Comments = comments;

        updateTicket(objTicket);


        changeScreen();
      }   
      else
      {
        const duplicateCcy = ticketRowsValidated.find(c => !c.validations.CurrencyID && c.CurrencyID !== '')
        if(duplicateCcy)
            {              
              //setDuplicateCcyMessage(`The Ticket has duplicate Currencies. Do you want to continue?`);       
              setNewRow({CurrencyID:'Valid'});
              //setShowDuplicateCcyConfirmation(true);
              setAlertTitle('Error');
              setAlertMessage('The Ticket has duplicate Currencies.');       
              setShowAlert(true);
            }
            else
            {
              setAlertTitle('Error');
              setAlertMessage('You missed some fields.');       
              setShowAlert(true);
            } 
      }               
    }

  }

  const getHeaders = () =>{
     return(
            <tr>
                <th key="2" width="25%">Recipient</th>                
                <th key="3" width="15%">Currency</th>
                <th key="4" width="15%" style={{textAlign:'right'}}>Amount</th>   
                <th key="5" width="25%">Instrument</th>                             
                <th key="6" width="15%">Delivery Method</th>
            </tr>
        );
  }

  const closeAlert = () => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
    };

  const openAlert = (title, message) => {
        setShowAlert(true);
        setAlertTitle(title);
        setAlertMessage(message);
    };


  const onTab = (e) => {

    if (e.key === 'Tab') {
      e.preventDefault();
      onAddClick();
    }
  }  


  const closeDuplicateCcyConfirmation = () =>{
    setNewRow({CurrencyID:''});
    setShowDuplicateCcyConfirmation(false);
  }  

  const yesDuplicateCcyConfirmation = () =>{
    if(newRow && newRow.CurrencyID !== '' && newRow.CurrencyID !== 'Valid')
    {
     const ticketR = [...ticketRows];
     ticketR.push(newRow);
     setTicketRows(ticketR);
    }
    else
    {
       onNextClick()
    }
     setShowDuplicateCcyConfirmation(false);
  }  

  const onNewTicketClick = () =>{
    if (window.isTicketChanged) {
            setShowNewTicketConfirmation(true);
        } else {
            newTicket(customerID, contactID, customerName, contactName);
        }
  }

  const closeNewTicketConfirmation = () =>{
    setShowNewTicketConfirmation(false);
  }

  const  yesNewTicketConfirmation = () =>{
    setShowNewTicketConfirmation(false);
    newTicket(customerID, contactID, customerName, contactName);
  }

  const handleChangeDeliveryDate = (dateValue) => {
    setDeliveryDate(dateValue);
  };

  const getRows=()=>{
        const rows = [];
        if(ticketRows)
        {
            ticketRows.forEach((t, index) =>{
              rows.push(<OutgoingRow key={t.key} customerID={customerID} rowObject={t} rowID={t.key} currenciesList={currenciesList} amountIsValid={amountIsValid}
                onDeleteRow={onDeleteRow} onUpdateFieldRow={onUpdateFieldRow} validations={t.validations} instruments={instruments} deliveryMethods={deliveryMethods}
                autoFocus={(ticketRows.length > 1 && index === ticketRows.length - 1 && (t.CurrencyID === undefined || t.CurrencyID === ''))} openAlert={openAlert} 
                recipientList={recipientList}/>);
            })
        }
        return rows;
    }

  const onCommentsChange = (e) =>{
        setComments(e.target.value);
    }


 
 return (
    <div>

        <div>
           
            <div className="uk-grid">

            <div className="uk-width-2-3 uk-form-controls">
              <div className="uk-grid">

                <div  className="uk-width-1-2 uk-form-controls">
                    <label className="uk-form-label">{'Customer:'}</label>
                    <input className="uk-input" id="customer-name" value={customerName} type="text" disabled={true} />
                </div> 

                <div  className="uk-width-1-2 uk-form-controls">
                    <label className="uk-form-label">{'Contact:'}</label>
                    <input className="uk-input" id="contact-name" value={contactName} type="text" disabled={true} />
                </div> 
                <div className="uk-width-1-2 uk-form-controls">
                    <label className="uk-form-label">{'Delivery/Pick up date:'}</label>
                    <DatePicker disabledDays={[0,6]} 
                        className={formatValidInput(validationsHeader.DeliveryDate)}                     
                        startDate={startDate} 
                        onDayChange={handleChangeDeliveryDate}
                        value={deliveryDate}/>
                
                </div>
              </div>

          </div>

                <div className="uk-width-1-3 uk-form-controls">
                  <NewDynamicTable 
                    data={balances}
                    enableSortByHeader = {true}
                    hiddenHeaders       = {['UpdateToken','Balance$']}
                  />

                </div>

                
            </div>
        
          <table className="uk-table uk-table-hover uk-table-divider border-table">
                <thead>
                        {getHeaders()}
                </thead>
                <tbody>
                        {getRows()}
                </tbody>
            </table>
                    
        </div>
        <div  align="right">
            <button id={'btn-ticket-add'} onKeyDown={onTab} key={'btn-ticket-add'} className="uk-button uk-button-green" onClick={onAddClick}>
                {'Add'}
            </button>
        </div>
        <Divider />

        <div className="uk-grid">
          <div  className="uk-width-1-1 uk-form-controls">
              <label className="uk-form-label">{'Comments:'}</label>
              <textarea id={'ticketComments'} key={'ticketComments'} className='uk-textarea' value={comments} onChange={onCommentsChange} /> 
          </div> 
        </div>

        <Divider />
        <div  align="right">

            <button className="uk-button uk-button-green" onClick={onNewTicketClick}>
                {'New'}
            </button>
            <button className="uk-button uk-button-green" onClick={onNextClick}>
                {'Next'}
            </button>
        </div>
        <LoadingBox loading={loading}/>
        <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
       {/*} <AlertBox id="void-confirmation"
                            open={showVoidConfirmation}
                            title="Confirmation"
                            message="Are you sure you want to void this ticket?"
                            type="Yes/No"
                            onClose={closeVoidConfirmation}
                            yesClick={yesVoidConfirmation}
                            noClick={closeVoidConfirmation}/>*/}
        <AlertBox id="void-confirmation-ccy"
                            open={showDuplicateCcyConfirmation}
                            title="Warning"
                            message={duplicateCcyMessage}
                            type="Yes/No"
                            onClose={closeDuplicateCcyConfirmation}
                            yesClick={yesDuplicateCcyConfirmation}
                            noClick={closeDuplicateCcyConfirmation}/>
        <AlertBox id="new-ticket-confirmation"
                            open={showNewTicketConfirmation}
                            title="Warning"
                            message={'You have unsaved changes. Your changes will be lost.'}
                            type="Yes/No"
                            onClose={closeNewTicketConfirmation}
                            yesClick={yesNewTicketConfirmation}
                            noClick={closeNewTicketConfirmation}/>
    </div>
  );
};

export default OutgoingInformationScreen